import { useQuery } from '@tanstack/react-query';

import { getBrandsAndProducts } from '~/services/overview-widget/overview-widget-service';

export const QUERY_KEY_BRANDS_AND_PRODUCTS = 'QUERY_KEY_BRANDS_AND_PRODUCTS';

export const useBrandsAndProducts = (entityTag: string, enabled = true) => {
  return useQuery({
    queryKey: [QUERY_KEY_BRANDS_AND_PRODUCTS, entityTag],
    queryFn: () => getBrandsAndProducts({ entityTag }),
    enabled,
  });
};
